import { Container, Grid, Link, Message, Stack, Text } from "basis";

function ActivateCardSuccess({ state }) {
  const { account, accountInfo } = state;
  const { cardName, cardImageFilename } = accountInfo;

  return (
    <Stack gap="8">
      <img
        width="272"
        height="224"
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        src={require(`../../images/cards/${cardImageFilename}`).default}
        alt={cardName}
        aria-hidden="true"
      />
      <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
        Your new {cardName} is now ready to be used
      </Text>
      <Text>
        Remember to sign the back of your card and ensure that any scheduled
        payments or existing direct debits are updated with your new card
        details.
      </Text>
      <Message severity="info-or-minor" bg="secondary.lightBlue.t25">
        A card PIN may be required for purchases above a certain amount. Set one
        up now in order to make purchases where a PIN may be required.
      </Message>
      <Container width="100%" width-xs="372">
        <Grid cols="2" colsGap="8">
          <Link
            appearance="primary-button"
            width="100%"
            href="/set-pin"
            newTab={false}
            state={{ account }}
          >
            Set card PIN
          </Link>
          <Link
            appearance="secondary-button"
            width="100%"
            href="/"
            newTab={false}
          >
            Go to overview
          </Link>
        </Grid>
      </Container>
    </Stack>
  );
}

export { ActivateCardSuccess };
